export const getLocale = () => {
	return 'ro';
};
